<template>
  <div class="flex h-full items-center justify-center">
      <button class="outline-none absolute left-auto right-4 top-4 text-center text-sm text-black z-10" @click="emit('close')" type="button">
          <img src="~/assets/icon/icon-close-gray-black.svg" alt="" class="h-8 rounded-full bg-black opacity-20">
      </button>
    <div
      class="relative flex max-w-xs flex-col items-center rounded-xl bg-blue-100 px-1 pb-20 pt-12 text-center lg:max-w-sm lg:pb-24"
    >
      <img
        class="h-12 lg:h-14"
        src="/fish.svg"
        alt=""
      />
      <strong class="mt-2 text-base font-bold uppercase lg:text-xl">спасибо за заказ</strong>
      <p class="mt-4 text-sm" v-if="isPaid">Ваш заказ уже успешно оплачен</p>
      <p class="mt-4 text-sm">Отследить статус заказа можно в личном кабинете, <span class="cursor-pointer" @click="goToOrders">откройте "Историю заказов"</span></p>
      <p class="mt-2 text-sm">Приятного аппетита!</p>

        <div class="absolute"></div>

      <img
        src="/happy-cup.svg"
        class="absolute top-0 h-24 -translate-y-3/4 transition-opacity lg:h-32"
        :class="isCupReady ? 'opacity-100' : 'opacity-0'"
        alt=""
      />

      <img
        src="/happy-sushi.svg"
        class="absolute bottom-0 h-32 max-w-none translate-y-1/2 transition-opacity lg:h-40"
        :class="isSushiReady ? 'opacity-100' : 'opacity-0'"
        alt=""
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useImage } from '@vueuse/core'
import { useProfileDialogStore } from '~/store/profileDialog'

const props = defineProps<{
    isPaid?: boolean
}>()
const { isPaid } = toRefs(props)

const emit = defineEmits(['close'])

const goToOrders = () => {
    emit('close')
    profileDialogStore.open('orders_history')
}
const profileDialogStore = useProfileDialogStore()
const { isReady: isCupReady } = useImage({ src: '/upset-cup.svg' })
const { isReady: isSushiReady } = useImage({ src: '/upset-sushi.svg' })
</script>
